/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // Optionally disable service worker during debugging by setting localStorage.disable_sw = '1'
  let disableSW = false
  try { disableSW = localStorage.getItem('disable_sw') === '1' } catch (e) { disableSW = false }
  if (disableSW && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const r of regs) {
        try { r.unregister().then(() => console.log('[sw] Unregistered service worker.', r)) } catch(e) { console.error('[sw] Unregister error', e) }
      }
    }).catch((e) => console.error('[sw] getRegistrations error', e))
  }

  let refreshing = false
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true
      // Ensure the new service worker controls the page and assets are refreshed.
      window.location.reload()
    })
  }

  let updateIntervalId = null
  const getUpdateIntervalMs = () => {
    const fromEnv = Number(process.env.VUE_APP_SW_UPDATE_INTERVAL_MS || '')
    if (Number.isFinite(fromEnv) && fromEnv > 0) return fromEnv
    try {
      const fromStorage = Number(localStorage.getItem('sw_update_interval_ms') || '')
      if (Number.isFinite(fromStorage) && fromStorage > 0) return fromStorage
    } catch (e) { /* ignore */ }
    return 5 * 60 * 1000
  }
  const schedulePeriodicUpdate = (registration) => {
    if (!registration || updateIntervalId) return
    const intervalMs = getUpdateIntervalMs()
    updateIntervalId = setInterval(() => {
      try { registration.update() } catch (e) { /* ignore */ }
    }, intervalMs)
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker. For more details, visit https://goo.gl/AFskqB')
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      schedulePeriodicUpdate(registration)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; refreshing...', registration)
      try {
        if (registration && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        }
      } catch (e) {
        console.error('[sw] skip waiting failed', e)
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
  // Also schedule in case the SW is already controlling the page.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((reg) => {
      schedulePeriodicUpdate(reg)
    }).catch(() => {})
  }
}
